// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu4/Item.css
// module id = 2036
// module chunks = 0